import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    if (err.response?.status === 401 && !cfg._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
      try {
        await refreshing;
        return api(cfg);
      } catch (refreshErr) {
        // Refresh failed (session expired): surface the original 401 to the caller.
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const rm = (sen = 0) => `RM${(sen / 100).toLocaleString("en-MY", { minimumFractionDigits: sen % 100 ? 2 : 0, maximumFractionDigits: 2 })}`;

export const todayMY = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kuala_Lumpur" });

export const addDays = (dateStr, n) => {
  const d = new Date(`${dateStr}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};

export const fmtDate = (dateStr, opts) => {
  const d = new Date(`${dateStr}T00:00:00Z`);
  const o = opts || { weekday: "short", day: "numeric", month: "short", ...(d.getUTCFullYear() !== new Date().getFullYear() && { year: "numeric" }) };
  return d.toLocaleDateString("en-MY", { ...o, timeZone: "UTC" });
};

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("en-MY", { timeZone: "Asia/Kuala_Lumpur", dateStyle: "medium", timeStyle: "short" }) : "-";

export const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const AVAILABILITY_POLL_MS = 15000;
const MINUTES_PER_DAY = 1440;

const toMin = (s) => {
  const [h, m] = s.split(":").map(Number);
  return h * 60 + m;
};
const toHm = (x) => {
  const v = ((x % MINUTES_PER_DAY) + MINUTES_PER_DAY) % MINUTES_PER_DAY;
  return `${String(Math.floor(v / 60)).padStart(2, "0")}:${String(v % 60).padStart(2, "0")}`;
};

export function generateSlots(open, close, duration) {
  const o = toMin(open);
  let c = toMin(close);
  if (c <= o) c += MINUTES_PER_DAY;
  const out = [];
  for (let t = o; t + duration <= c; t += duration) out.push({ start: toHm(t), end: toHm(t + duration), offset: t });
  return out;
}

export const durationLabel = (min) => (min % 60 ? `${(min / 60).toFixed(1)} hr` : `${min / 60} hr`);
